// extracted by mini-css-extract-plugin
export default {"radioClass":"RadioBoxLabel_radioClass__Uu0S9"};